// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dCn1k","right":"styles_right__LHCPR"};